<template>
	<div class="mobCalc">
	  <div class="cap_logo border-bottom d-flex align-items-center">
		<!-- <button type="button" id="sidebarCollapse" class="btn-btn mr-3"><i data-feather="align-left"></i></button> -->
		<div class="mobTop-menu">
		  <div class="navbar-light">
			<button @click="menuToggle = !menuToggle" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			  <span class="navbar-toggler-icon"></span>
			</button>
		  </div>
		</div>
		<div class="logoMian w-100">
		  <router-link title="Dashboard" :to="'/dashboard'" class="green">
			<img src="../../../../static/fxView/images/logo1.png" alt="Logo">
		  </router-link>
		</div>
	  </div>
	  <div id="sidebar" class="pt-0" :class="menuToggle?'activeShow':' '">
		<div class="cap_leftbar p_right">
		  <div class="left_scrollbar">
			<div class="scrollbar">
			  <nav class="side-navbar main-menu">
				<ul id="side-main-menu" class="side-menu list-unstyled">
				  <li>
					<router-link title="Dashboard" :to="'/dashboard'" :class="($route.path == '/dashboard')?'tabActive' :''">
					  <span class="sprite1 bgIcon">
						<feather type="layout"></feather>
					  </span> Dashboard
					</router-link>
				  </li>
				  <li v-if="get_user.roles.indexOf('RM') != -1 || get_user.roles.indexOf('RM-A') != -1 || get_user.roles.indexOf('RM-M') != -1">
					<router-link title="request-access" :to="'/request-access'" :class="($route.path == '/request-access')?'tabActive' :''">
					  <span class="sprite1 bgIcon">
						<feather type="layout"></feather>
					  </span> Request Access
					</router-link>
				  </li>
				  <!--<li v-if="permissionModule('REPORT_LIST','view')"><router-link title="Dashboard" :to="'/reporting'" :class="($route.path == '/reporting')?'tabActive' :''"><span class="sprite1 bgIcon"><feather type="columns"></feather></span> Reporting
						  </router-link></li>-->
				  <li v-if="permissionModule('ADMIN_LIST','view')">
					<router-link title="users-list" :to="'/admin-list'" :class="($route.path == '/admin-list' || $route.path == '/admin-view')?'tabActive' :''">
					  <span class="sprite2 bgIcon">
						<feather type="file-text"></feather>
					  </span> Admin List
					</router-link>
				  </li>
				  <!--<li><router-link title="users-list" :to="'/coupon-listing'" :class="($route.path == '/coupon-listing' || $route.path == '/create-coupon')?'tabActive' :''"><span class="sprite2 bgIcon"><feather type="package"></feather></span> Coupon List
						  </router-link></li>	-->
				  <li v-if="permissionModule('CLIENT_LIST','view')">
					<router-link title="users-list" :to="'/listing'" :class="($route.path == '/listing' || $route.path == '/view')?'tabActive' :''">
					  <span class="sprite2 bgIcon">
						<feather type="user-check"></feather>
					  </span> Client List
					</router-link>
				  </li>
				  <li v-if="permissionModule('MANAGE_GROUP_LIST','view')">
					<router-link title="users-list" :to="'/group-listing'" :class="($route.path == '/group-listing' || $route.path == '/group-view')?'tabActive' :''">
					  <span class="sprite2 bgIcon">
						<feather type="user-check"></feather>
					  </span> Manage Group
					</router-link>
				  </li>
				  <!-- <li>
					<router-link title="users-list" :to="'/task-listing'" :class="($route.path == '/task-listing')?'tabActive' :''">
					  <span class="sprite2 bgIcon">
						<feather type="user-check"></feather>
					  </span> Task List
					</router-link>
				  </li>
				  <li>
					<router-link title="users-list" :to="'/notes'" :class="($route.path == '/notes')?'tabActive' :''">
					  <span class="sprite2 bgIcon">
						<feather type="user-check"></feather>
					  </span> Internal Notes
					</router-link>
				  </li> -->
				  <li v-if="permissionModule('WITHDRAWAL_LIST','view')">
					<router-link title="withdrawal-list" :to="'/withdrawal-list'" :class="($route.path == '/withdrawal-list' || $route.path == '/withdrawal-view')?'tabActive' :''">
					  <span class="sprite3 bgIcon">
						<feather type="credit-card"></feather>
					  </span>Client's Withdrawal List
					</router-link>
				  </li>
				  <li v-if="permissionModule('MANUAL_WITHDRAWAL_LIST','view')">
					<router-link title="withdrawal-account-list" :to="'/withdrawal-account-list'" :class="($route.path == '/withdrawal-account-list')?'tabActive' :''">
					  <span class="sprite3 bgIcon">
						<feather type="book"></feather>
					  </span> Manual Withdrawal List
					</router-link>
				  </li>
				  <li v-if="permissionModule('DEPOSIT_LIST','view')">
					<router-link title="deposit-list" :to="'/deposit-list'" :class="($route.path == '/deposit-list' || $route.path == '/deposit-view')?'tabActive' :''">
					  <span class="sprite4 bgIcon">
						<feather type="layers"></feather>
					  </span> Deposit List
					</router-link>
				  </li>
				  <!--<li v-if="permissionModule('BONUS_LIST','view')"><router-link title="bonus-list" :to="'/bonus-list'" :class="($route.path == '/bonus-list' || $route.path == '/bonus-view')?'tabActive' :''"><span class="sprite4 bgIcon"><feather type="database"></feather></span> Bonus List
						  </router-link></li>-->
				  <li v-if="permissionModule('TRADING_LIST','view')">
					<router-link title="trading-list" :to="'/trading-list'" :class="($route.path == '/trading-list' || $route.path == '/trading-view')?'tabActive' :''">
					  <span class="sprite5 bgIcon">
						<feather type="trending-up"></feather>
					  </span> Trading List
					</router-link>
				  </li>
				  <!-- <li  v-if="permissionModule('MANUAL_DEPOSIT_LIST','view')"><router-link title="internal-deposit-list" :to="'/internal-deposit-list'" :class="($route.path == '/internal-deposit-list')?'tabActive' :''"><span class="sprite4 bgIcon"><feather type="tag"></feather></span> Manual Deposit List
						  </router-link></li> -->
				  <li v-if="permissionModule('TICKET_LIST','view')">
					<router-link title="ticket-list" :to="'/ticket-list'" :class="($route.path == '/ticket-list' || $route.path == '/ticket-view')?'tabActive' :''">
					  <span class="sprite4 bgIcon">
						<feather type="tag"></feather>
					  </span> Ticket List
					</router-link>
				  </li>
				  <!-- <li class="knowledgeMenu" :class="(pricing)?'active': ''" ><a class="d-flex align-items-center justify-content-between bottom_drop" href="#" @click="pricing = !pricing"><div class="imgeFlow"><img src="../../../../static/fxView/images/nicePng_bas.png" alt="Icon"></div><span>Pricing</span></a><ul class="sub-menu"><li ><router-link title="plan" :to="'/plan-listing'" :class="($route.path == '/plan-listing')?'tabActive' :''"><span class="sprite1 bgIcon"><feather type="stop-circle"></feather></span> Plan List
								  </router-link></li><li ><router-link title="offer" :to="'/offer-listing'" :class="($route.path == '/offer-listing')?'tabActive' :''"><span class="sprite1 bgIcon"><feather type="list"></feather></span> Offer List
								  </router-link></li></ul></li>  -->
				  <li v-if="permissionModule('TICKET_LIST','view')">
					<router-link title="web-hooks" :to="'/web-hooks'" :class="($route.path == '/web-hooks')?'tabActive' :''">
					  <span class="sprite1 bgIcon">
						<feather type="layout"></feather>
					  </span> Web Hooks
					</router-link>
				  </li>
				  <!--v-if="permissionModule('PRICING','view')"-->
				  <li v-if="permissionModule('PRICING','view')">
					<a :class="($route.path == '/plan-listing' || $route.path == '/create-plan' || $route.path == '/plan-view' || $route.path == '/offer-listing' || $route.path == '/create-offer' || $route.path == '/offer-view')?'tabActive' :''" @click.prevent="leftMenu ^= true" href="javascript:void(0)" title="Pricing">
					  <span class="sprite1 bgIcon">
						<feather type="dollar-sign" size="14px"></feather>
					  </span> Pricing <feather type="chevron-down" size="14px" class="float-right mt-1"></feather>
					</a>
					<ul class="sub-menu" :class="{'show':leftMenu}">
					  <li>
						<router-link title="plan" :to="'/plan-listing'" :class="($route.path == '/plan-listing' || $route.path == '/create-plan' || $route.path == '/plan-view')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="book"></feather>
						  </span> Plan List
						</router-link>
					  </li>
					  <li>
						<router-link title="offer" :to="'/offer-listing'" :class="($route.path == '/offer-listing' || $route.path == '/create-offer' || $route.path == '/offer-view')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="list"></feather>
						  </span> Offer List
						</router-link>
					  </li>
					</ul>
				  </li>

				  <li  >
					<a :class="($route.path == '/cards-individual-users' || $route.path == '/cards-sub-users' || $route.path == '/cards-user-wallets' || $route.path == '/cards-transaction-listing')?'tabActive' :''" @click.prevent="leftMenu1 ^= true" href="javascript:void(0)" title="Pricing" >
					  <span class="sprite1 bgIcon" >
						<feather type="dollar-sign" size="14px"></feather>
					  </span> Virtual Debit Cards <feather type="chevron-down" size="14px" class="float-right mt-1"></feather>
					</a>
					<ul class="sub-menu" :class="{'show':leftMenu1}">
					  <li>
						<router-link title="plan" :to="'/cards-individual-users'" :class="($route.path == '/cards-individual-users' || $route.path == '/cards-sub-users' || $route.path == '/cards-user-wallets')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="book"></feather>
						  </span> Card Users
						</router-link>
					  </li>
					  <!--  <li>
						<router-link title="plan" :to="'/cards-user-listing'" :class="($route.path == '/cards-user-listing')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="book"></feather>
						  </span> Users Details
						</router-link>
					  </li> -->
					  <li>
						<router-link title="offer" :to="'/cards-transaction-listing'" :class="($route.path == '/cards-transaction-listing')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="list"></feather>
						  </span> Card Transaction History
						</router-link>
					  </li>
					</ul>
				  </li>

				  <li>
					<router-link title="ticket-list" :to="'/fee-history'" :class="($route.path == '/fee-history')?'tabActive' :''">
					  <span class="sprite4 bgIcon">
						<feather type="tag"></feather>
					  </span> Fee History
					</router-link>
				  </li>
				  <li class="knowledgeMenu" :class="(knowlegdeBase)?'active': ''" v-if="permissionModule('CREATE_CATEGORY','view') || permissionModule('CATEGORY_LIST','view') || permissionModule('CREATE_ARTICLE','view') || permissionModule('ARTICLE_LIST','view')">
					<a class="d-flex align-items-center justify-content-between bottom_drop" href="#" @click="knowlegdeBase = !knowlegdeBase">
					  <div class="imgeFlow">
						<img src="../../../../static/fxView/images/nicePng_bas.png" alt="Icon">
					  </div>
					  <span>Knowledge Base</span>
					</a>
					<ul class="sub-menu">
					  <li v-if="permissionModule('CREATE_CATEGORY','view')">
						<router-link title="category" :to="'/category'" :class="($route.path == '/category')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="stop-circle"></feather>
						  </span> Knowledge Base Category
						</router-link>
					  </li>
					  <li v-if="permissionModule('CATEGORY_LIST','view')">
						<router-link title="Dashboard" :to="'/category-list'" :class="($route.path == '/category-list')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="list"></feather>
						  </span> Category List
						</router-link>
					  </li>
					  <li v-if="permissionModule('CREATE_ARTICLE','view')">
						<router-link title="articles" :to="'/articles'" :class="($route.path == '/articles')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="file"></feather>
						  </span> Knowledge Base Article
						</router-link>
					  </li>
					  <li v-if="permissionModule('ARTICLE_LIST','view')">
						<router-link title="Dashboard" :to="'/articles-list'" :class="($route.path == '/articles-list')?'tabActive' :''">
						  <span class="sprite1 bgIcon">
							<feather type="edit"></feather>
						  </span> Article List
						</router-link>
					  </li>
					</ul>
				  </li>
				  <!-- <li><a href="#"  @click="logout()" title="Logout"><span class="sprite1 bgIcon"></span> Logout
						  </a></li> -->
				</ul>
			  </nav>
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </template>
  <script>
	import {
	  fxViewMixins
	} from '@/plugins/fxView'
	import {
	  LayoutIcon,
	  UserIcon,
	  UsersIcon,
	  LogOutIcon
	} from 'vue-feather-icons'
	export default {
	  name: 'fxViewApp',
	  mixins: [fxViewMixins],
	  data() {
		return {
		  knowlegdeBase: false,
		  knowlegdeBase1: false,
		  menuToggle: false,
		  pricing: false,
		  leftMenu: false,
		  leftMenu1: false,
		}
	  },
	  components: {
		LayoutIcon,
		UsersIcon,
		UserIcon,
		LogOutIcon
	  },
	  methods: {},
	  mounted() {
		$('.dropdown').click(function() {
		  $(this).addClass('active').siblings().removeClass('active');
		});
		const _that = this
		$(document).on("click", function(event) {
		  if (!$(event.target).closest('.bottom_drop').length) {
			_that.knowlegdeBase = false
		  }
		});
		$(document).on("click", function(event) {
		  if (!$(event.target).closest('.bottom_drop').length) {
			_that.pricing = false
		  }
		});
	  }
	}
  </script>


// WEBPACK FOOTER //
// src/components/website/shared/left_navigation.vue